import { render, staticRenderFns } from "./WongBakerFacesInput.vue?vue&type=template&id=54ba64fb&scoped=true&"
import script from "./WongBakerFacesInput.vue?vue&type=script&lang=ts&"
export * from "./WongBakerFacesInput.vue?vue&type=script&lang=ts&"
import style0 from "./WongBakerFacesInput.vue?vue&type=style&index=0&id=54ba64fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba64fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
